module.exports = __webpack_public_path__ + "48e059f9fbd41ac781588eed3ac694ba.png";